import { ShoppingCartIcon } from "@heroicons/react/24/outline";
import useBaskets from "../../data/useBaskets";
import { useEffect, useState } from "react";
import classNames from "../../utils/classNames";
import { useNavigate } from "react-router-dom";
import Basket from "../../pages/Basket/Basket";
import Drawer from "../../layouts/Drawer";


export default function CurrentBasket() {
  const { getBasket } = useBaskets("CurrentBasket");
  const navigate = useNavigate();
  const [basketItems, setBasketItems] = useState(0);
  const [animate, setAnimate] = useState(false);
  const [basketOpen, setBasketOpen] = useState(false);

  useEffect(() => {
    if (getBasket.data) {

      if (!getBasket.data.data.items || getBasket.data.data.items.length === 0) {
        setBasketItems(0);
        return;
      }

      const totalItems = getBasket.data.data.items.length;

      if (totalItems !== basketItems && totalItems > 0) {
        setAnimate(true);
        setTimeout(() => setAnimate(false), 300);
      }

      setBasketItems(totalItems);
    }
  }, [getBasket.data, getBasket.isLoading]);

  return (
    <div>
      <Drawer open={basketOpen} setOpen={setBasketOpen} title="Basket" maxWidth="max-w-[90vw]">
        <Basket />
      </Drawer>
      <div
        // onClick={() => navigate("/basket")}
        onClick={() => setBasketOpen(true)}
        className={classNames(animate ? "scale-125" : "", "select-none relative cursor-pointer transition-all hover:text-bold hover:scale-125")}
      >
        {basketItems > 0 && <div className="absolute -top-1 -right-1 text-center text-xs bg-red-600 text-white rounded-full h-4 w-4">{basketItems}</div>}
        <ShoppingCartIcon className="h-6 w-6" aria-hidden="true" />
      </div>
    </div>
  )

};